import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { searchCities } from '../../../services/city';
import SearchForm from '../SearchForm/SearchForm';
import css from './SearchFilter.module.css';

function WineryCityFilter({
  cities,
  setCities,
  setCitiesLoading,
  selectedCities,
  setSelectedCities
}) {
  const [limit, setLimit] = useState(3);
  const [searchCityValue, setSearchCityVlaue] = useState("")

  const handleSearchCity = (e) => {
    e.preventDefault();
    searchCities(searchCityValue, setCitiesLoading, setCities);
  }

  const handleOnChange = (e) => {
    if(e.target.checked){
      setSelectedCities([...selectedCities, e.target.name])
    } else {
      setSelectedCities([...selectedCities].filter(x => x !== e.target.name))
    }
  }

  return (
    <div>
      <h3>Winery City</h3>
      <SearchForm
        handleSubmit={handleSearchCity}
        searchValue={searchCityValue}
        setSearchVlaue={setSearchCityVlaue}
        rootClassName={css.searchBarWrapper}
        searchBarIcon={css.searchIcon}
        searchBarClassName={css.searchBar}
        placeholder="Search City"
      />
      {cities && cities.sort().slice(0, limit).map((city, index) => (
        <div key={index} style={{display: 'flex', alignItems: 'center'}}>
          <input
            type="checkbox"
            id={city.name}
            name={city.name}
            onChange={handleOnChange}
            checked={selectedCities?.includes(city.name)}
            style={{display: 'inline-block', width: 'auto', marginRight: "10px"}}
          />
          <label htmlFor="">{city.name}</label>
        </div>
      ))}
      {cities && cities.length > limit ? (
        <div style={{cursor: "pointer"}} onClick={() => setLimit(prev => prev + 3)}>
          <small>... see more</small>
        </div>
      ) : null}
    </div>
  )
}

export default WineryCityFilter;
